import { render, staticRenderFns } from "./LayoutMinimal.vue?vue&type=template&id=f0dc562e&scoped=true&"
import script from "./LayoutMinimal.vue?vue&type=script&lang=js&"
export * from "./LayoutMinimal.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMinimal.vue?vue&type=style&index=0&id=f0dc562e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dc562e",
  null
  
)

export default component.exports